import React, { useState } from 'react';
import ProfileDetailRow, {
    ProfileRowPlacementType,
} from '../profile/ProfileDetailRow';
import { Connection } from '../../gql/types';
import styles from './InOverlaySelectableConnectionRow.module.css';
import checkIcon from "../../assets/icons/checkMark.svg"; // assuming this exists
import FamilyProfileOverlaySheet from '../profile/family/FamilyProfileOverlaySheet';
import { OverlayOpacity } from '../portal/types';

type InOverlaySelectableConnectionRowProps = {
    connection: Connection;
    isSelected: boolean;
    onToggle: () => void;
};

const InOverlaySelectableConnectionRow: React.FC<InOverlaySelectableConnectionRowProps> = ({
    connection,
    isSelected,
    onToggle,
}) => {
    const [showFamilyProfileView, setShowFamilyProfileView] = useState(false);

    const { participant } = connection;

    let name: string;
    let profilePictureUrl: string | undefined;

    switch (participant.__typename) {
        case "UserSummary":
            name = `${participant.firstName || ""} ${participant.lastName || ""}`.trim();
            profilePictureUrl = participant.profilePictureUrl || undefined;
            break;
        case "FamilySummary":
            name = participant.name === "" ? "Family" : participant.name;
            profilePictureUrl = participant.parents?.[0]?.profilePictureUrl || undefined;
            break;
        default:
            name = "";
    }

    return (
        <>
            <div
                className={`${styles.row} ${isSelected ? styles.selectedRow : ""}`}
            >
                <ProfileDetailRow
                    name={name}
                    profilePictureUrl={profilePictureUrl}
                    altText={participant.id}
                    placement={ProfileRowPlacementType.LIST}
                    onProfilePictureClick={() => setShowFamilyProfileView(true)}
                />
                <div
                    className={`${styles.checkContainer} ${isSelected ? styles.checked : styles.unChecked}`}
                    onClick={onToggle}>
                    {isSelected && <img src={checkIcon} alt="Selected" className={styles.checkIcon} />}
                </div>
            </div>
            {showFamilyProfileView && (
                <FamilyProfileOverlaySheet
                    onBack={() => setShowFamilyProfileView(false)}
                    connection={connection}
                    onContinue={() => {
                        setShowFamilyProfileView(false);
                        if (!isSelected) {
                            onToggle();
                        }
                    }}
                    continueButtonText={"Add to Guest List"}
                    overlayOpacity={OverlayOpacity.COVERED}
                />
            )}
        </>
    );
};

export default InOverlaySelectableConnectionRow;
